/**
 *  账户相关 API 地址
 *  @swagger http://customer-bff-tst.earth.xpaas.lenovo.com/swagger-ui.html#/
 */
import { IAjaxConfig } from '../helpers';
export class EnumApiBffsvr {
  /**
   * @dec 登陆
   * @method post
   * @params loginType password userName  validationCode
   */
  readonly bffsvr_login: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/login/mobile',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 登陆 微信小程序
   * @memberof EnumApiBffsvr
   */
  readonly bffsvr_login_wechat: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/login/wechat',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec token 获取用户信息
   */
  readonly bffsvr_user: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/getUserCenterInfo',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec token 获取用户信息
   */
  readonly bffsvr_user_token: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/token',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec token 获取埋点信息
   */
  readonly bffsvr_user_buriedPointCollect: IAjaxConfig = {
    // url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/token/buriedPointCollect',
    url: '/api/gateway/partner-bff/api/event/tracking',
    method: 'get',
  };
  /**
   * @dec 图片验证码
   */
  readonly bffsvr_imgCode: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/imgCode',
    method: 'post',
    awaitAuthenticated: false,
  };
  /**
   * @dec 发送短信验证码
   * @params imgCode imgSession mobilePhone sendType
   */
  readonly bffsvr_SendCode: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/user/sendValidationCode?imgCode={imgCode}&imgSession={imgSession}&mobilePhone={mobilePhone}&sendType={sendType}',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 个人中心-更改基本信息 TODO:replace accountsvr_update_userinfo
   */
  // readonly bffsvr_updateUserCenterInfo: IAjaxConfig = {
  //     url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/updateUserCenterInfo',
  //     method: 'put',
  //     loading: true,
  // };

  /**
   * @dec 个人中心-更改图像
   */
  readonly bffsvr_updateAvatar: IAjaxConfig = {
    url: `/api/gateway/pcsd-bp-customer-bffsvr/v2/user/updatePortrait`,
    method: 'put',
    loading: true,
  };

  /**
   * @dec 个人中心-更改地址信息
   */
  readonly bffsvr_updateUserExtend: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/updateUserExtend',
    method: 'put',
    loading: true,
  };

  /**
   * @dec 个人中心-获取k码
   */
  readonly bffsvr_getResellerByTax: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/getResellerByTax',
    method: 'get',
  };

  /**
   * @dec 个人中心-k码登陆-绑定手机号
   */
  readonly bffsvr_k2mobile: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/bind/k2mobile',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 个人中心-手机号登陆-绑定k码
   */
  readonly bffsvr_mobile2k: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/bind/mobile2k',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 企业认证 - token 获取企业认证信息
   */
  readonly bffsvr_auth_token: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/userVerified/token',
    loading: true,
    // cache:true,
  };

  /**
   * @dec 企业认证 - 营业执照识别
   */
  readonly bffsvr_auth_ocrBusLicense: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/userVerified/ocr/busLicense',
    loading: true,
  };

  /**
   * @dec 企业认证 - 身份证识别
   */
  readonly bffsvr_auth_idCard: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/userVerified/ocr/idCard/front',
    loading: true,
  };

  /**
   * @dec 企业认证 - 提交认证
   */
  readonly bffsvr_auth_submit: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/userVerified/certification',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 地址列表
   * @params
   */
  readonly bffsvr_address: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/address/findList',
    method: 'post',
    // cache: true,
    loading: true,
  };
  /**
   * @dec 地址详情
   * @params
   */
  readonly bffsvr_address_details: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/address/{id}',
    loading: true,
  };
  /**
   * @dec 地址添加
   * @params
   */
  readonly bffsvr_address_add: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/address/add',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 地址修改
   * @params
   */
  readonly bffsvr_address_update: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/address/update',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 地址删除
   * @params
   */
  readonly bffsvr_address_delete: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/address/delete',
    method: 'post',
    loading: true,
  };
  /**
   * @dec isg地址列表
   * @params
   */
  readonly bffsvr_isg_address: IAjaxConfig = {
    url: 'api/gateway/pcsd-bp-customer-bffsvr/organization/address/findListByToken',
    method: 'get',
    // cache: true,
    loading: true,
  };
  /**
   * @dec isg地址添加
   * @params
   */
  readonly bffsvr_isg_address_add: IAjaxConfig = {
    url: 'api/gateway/pcsd-bp-customer-bffsvr/organization/address/add',
    method: 'post',
    loading: true,
  };
  /**
   * @dec isg地址修改
   * @params
   */
  readonly bffsvr_isg_address_update: IAjaxConfig = {
    url: 'api/gateway/pcsd-bp-customer-bffsvr/organization/address/update',
    method: 'post',
    loading: true,
  };
  /**
   * @dec isg地址删除
   * @params
   */
  readonly bffsvr_isg_address_delete: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/organization/address/delete',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 积分查询 总体
   * @params
   */
  readonly bffsvr_integral_total: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/integral/token',
    loading: true,
  };

  /**
   * @dec 积分查询 列表
   * @params
   */
  readonly bffsvr_integral_list: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/integral/list/token',
    method: 'post',
    loading: true,
  };

  /**
   * @dec sales 我的二维码
   * @params
   */
  readonly bffsvr_poster_list: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v2/sales/promotion/poster',
    loading: true,
  };

  /**
   * @dec sales 我的邀请客户
   * @params
   */
  readonly bffsvr_invitationPage_list: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/token/sales/invitation',
    method: 'post',
    loading: true,
  };

  /**
   * @dec sales 我的区域客户
   * @params
   */
  readonly bffsvr_regionPage_list: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/token/region',
    method: 'post',
    loading: true,
  };

  /**
   * @dec isg 消息提醒
   * @params
   */
  readonly bffsvr_notificationPage_list: IAjaxConfig = {
    url: '/api/gateway/message-portal/msg/count',
    method: 'get',
    // loading: true,
    loading: false,
  };

  /**
   * @dec 注册时候验证手机号是否存在
   */
  readonly bffsvr_existMobile: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/checkUserExist/{usercode}',
  };

  /**
   * @dec 注册账号
   */
  readonly bffsvr_register: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/register',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 找回密码
   */
  readonly bffsvr_retrievePwd: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/retrievePwd',
    method: 'put',
    loading: true,
  };

  /**
   * @dec 修改密码
   */
  readonly bffsvr_updatePwd: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/user/updatePwd',
    method: 'put',
    loading: true,
  };
  /**
   * @dec 获取新手指引状态
   */
  readonly bffsvr_guide_get: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/guide/status/get',
  };
  /**
   * @dec 设置新手指引状态
   */
  readonly bffsvr_guide_set: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/guide/status/set',
    method: 'put',
  };
  /**
   * @dec 我的审批菜单权限判断
   */
  readonly bffsvr_examine: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/isg/isApproval',
    method: 'get',
    loading: false,
  };
}
